import { useMemo } from "react";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";
import type { RunTileReportRequest } from "../../../../../../../../api/types/svTypes.ts";

interface Props {
  sessionId: string;
  isQueryLoggingActive: boolean | undefined;
}
const useRequestConfigViewer = ({ sessionId, isQueryLoggingActive }: Props) => {
  const { reportId, conditions } = useBiCommonDataContext();

  const requestConfig = useMemo(() => {
    const request: RunTileReportRequest = {
      conditions: conditions
        .filter((c) => c.config.parameter === true)
        .map((c) => ({ ...c.config, invalid: c.validation?.invalid })),
      sessionId,
      reportId: reportId ?? "",
      useQueryLogging: isQueryLoggingActive === true,
    };
    return request;
  }, [conditions, reportId, sessionId, isQueryLoggingActive]);

  return { requestConfig };
};

export default useRequestConfigViewer;
